import React from 'react';
import { Grid, Button } from '@material-ui/core';
import { FaAngleRight } from "react-icons/fa";
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
    root: {
      [theme.breakpoints.down("sm")]: {
        marginBottom: "1rem"
      },
      [theme.breakpoints.up("sm")]: {
        display: 'flex',
        backgroundColor: "transparent",
        marginBottom: "7rem"
      },
    },
    containerTop: {
      [theme.breakpoints.down("sm")]: {
        marginTop: ".5rem"
      },
      [theme.breakpoints.up("sm")]: {
        marginTop: "7rem"
      },
    },
    containerTopLeft: {
      [theme.breakpoints.down("sm")]: {
        padding: "0 .5rem",
        marginBottom: "2.5rem"
      },
      [theme.breakpoints.up("sm")]: {
        padding: "0",
        marginTop: "-1rem"
      },
    },
    containerTopRight: {
      [theme.breakpoints.down("sm")]: {
        padding: "0 .5rem",
        marginBottom: "2.5rem"
      },
      [theme.breakpoints.up("sm")]: {
        padding: "0 0 0 2rem",
      },
    },
    headerPhone: {
      [theme.breakpoints.down("sm")]: {
        marginTop: '1rem',
        width: "100%"
      },
      [theme.breakpoints.up("sm")]: {
        width: "80%"
      },
    },
    tagline: {
      [theme.breakpoints.down("sm")]: {
        fontSize: '24px',
        color: '#2c2c2c',
        fontWeight: '700'
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: '28px',
        color: '#fff',
        fontWeight: '500'
      },
    },
    descTagline: {
      [theme.breakpoints.down("sm")]: {
        fontSize: '16px',
        color: '#4c4c4c',
        fontWeight: '400'
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: '17px',
        color: '#c1c1c1',
        fontWeight: '400'
      },
    }
  }));

    const ContentBlock = ({ t }) => {
    const classes = useStyles();
    const history = useHistory()

    const gotoContactPage = () => {
      history.push('/contactUs')    
    }
    
    return (
        <div className={classes.root}>
          <Grid className={classes.containerTop} container direction="row" >
            <Grid className={classes.containerTopLeft} container xs={12} md={6} >
              <img className={classes.headerPhone} src="/header-phone.png" />
            </Grid>
            <Grid item xs={12} md={6} className={classes.containerTopRight}>
              <p className={classes.tagline} style={{lineHeight : "1.5"}} align="left" >{t('content.tagline')}</p>
              <p className={classes.descTagline}>{t('content.descTagline')}</p>
              <Button className="btn-white" style={{padding: "5px 20px"}} onClick={gotoContactPage}>
                {t('content.getStarted')}
                <span className="pl-3">&ensp;<FaAngleRight /></span>
              </Button>
            </Grid>
          </Grid>
          
      </div>
    )
}

export default withTranslation()(ContentBlock);